import React from 'react';
import { forwardRef, ReactNode, useImperativeHandle } from 'react';
import { Form } from '@ant-design/compatible';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { ValidationRule } from '@ant-design/compatible/lib/form/Form';
import cx from 'classnames';
import ImageAndVideoUploadV2 from '../../input/ImageAndVideoUploadV2';
import { ImageAndVideoUploadProps } from '../../input/ImageAndVideoUploadV2/ImageAndVideoUploadV2';
import { Attachment } from '../../input/ImageAndVideoUploadV2/types';
import { ImageAndVideoUploadFormStyle } from './style';

interface IImageAndVideoUploadFormProps extends FormComponentProps, ImageAndVideoUploadProps {
  className?: string;
  label?: string | ReactNode;
  name: string;
  rules?: ValidationRule[];
  vertical?: boolean;
  subContent?: string | ReactNode;
  showInfo?: boolean;
  initialValue?: Attachment[];
}
const ImageAndVideoUploadForm = forwardRef<FormComponentProps, IImageAndVideoUploadFormProps>((props, ref) => {
  const {
    className,
    form,
    label,
    rules,
    name,
    initialValue,
    onChange,
    vertical = false,
    subContent,
    showInfo = true,
    ...res
  } = props;
  const { getFieldDecorator } = form;

  useImperativeHandle(ref, () => ({
    form,
  }));

  return (
    <ImageAndVideoUploadFormStyle className={className}>
      <Form.Item
        className={cx('image-and-video-upload-form', 'amondz-form', { 'with-label': label }, { vertical })}
        label={label}
      >
        {getFieldDecorator(name, {
          rules,
          initialValue,
        })(<ImageAndVideoUploadV2 onChange={onChange} {...res} />)}
      </Form.Item>
      {subContent && showInfo ? <div className="amondz-form-sub-content"> {subContent}</div> : null}
    </ImageAndVideoUploadFormStyle>
  );
});
ImageAndVideoUploadForm.displayName = 'ImageAndVideoUploadForm';

export default ImageAndVideoUploadForm;
